import { render, staticRenderFns } from "./CoTwoGeneratorEnergyForm.vue?vue&type=template&id=45741ccd&scoped=true&"
import script from "./CoTwoGeneratorEnergyForm.vue?vue&type=script&lang=js&"
export * from "./CoTwoGeneratorEnergyForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45741ccd",
  null
  
)

export default component.exports